export default function ServicesGrid() {
  const services = [
    {
      icon: 'ri-palette-line',
      title: 'Logo Pack',
      description: 'Complete logo package with multiple concepts and comprehensive brand guidelines to establish your visual identity.',
      features: [
        'Two logo concepts to choose from',
        'Logo overview',
        'Primary logo',
        'Logo variations',
        'Correct logo usage',
        'Incorrect logo usage',
        'Color palette',
        'HEX, RGB, and CMYK color codes',
        'Typography: primary and secondary fonts'
      ]
    },
    {
      icon: 'ri-brush-line',
      title: 'Visual Identity Pack',
      description: 'Ideal for businesses ready for a stronger visual identity and more flexibility across platforms.',
      subtitle: 'What we offer:',
      features: [
        'Two creative concepts to choose from',
        'Logo: Logo overview, Primary logo, Logo variations',
        'Color: Color palette, HEX, RGB, and CMYK color codes, Color variations and combinations',
        'Typography: Primary and secondary fonts, Font styles, Typography hierarchy'
      ]
    },
    {
      icon: 'ri-book-open-line',
      title: 'Branding Package',
      description: 'A complete branding system that defines how your business looks, feels, and communicates at every touchpoint.',
      subtitle: 'What we offer:',
      features: [
        'Two creative concepts to choose from',
        'Brand Strategy: Brand book (usage guide), Brand concept and philosophy, Brand principles',
        'Logo: Logo overview, Primary logo',
        'Color: Color palette',
        'Typography: Primary and secondary fonts, Font styles',
        'Brand Elements and Applications: Brand element set and/or illustrations, Brand pattern',
        'Three real-world applications of the brand identifier'
      ]
    },
    {
      icon: 'ri-megaphone-line',
      title: 'Social Media Management & Digital Presence',
      description: 'Build and maintain a powerful online presence that engages your audience and grows your brand across all digital platforms.',
      subtitle: 'What we offer:',
      features: [
        'Content Creation & Scheduling.',
        'Monthly Content Calendar.',
        'Community Management.',
        'Social Media Ads (Meta / Instagram / Google Ads).',
        'Weekly Call.',
        'Analytics & Performance Review.'
      ]
    }
  ];

  return (
    <section id="services" className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold text-[#182114] mb-6" style={{ fontFamily: '"Distro Bold", sans-serif' }}>
            What We <span className="text-[#D96B33]">Offer</span>
          </h2>
          <div className="w-24 h-1 bg-[#D96B33] mx-auto mb-8"></div>
          <p className="text-xl text-[#2E3F25] max-w-3xl mx-auto" style={{ fontFamily: '"Century Gothic", sans-serif' }}>
            Strategic branding and digital solutions that elevate your business presence
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-[#EBEBE0] p-8 rounded-3xl hover:bg-white hover:shadow-2xl transition-all duration-500 cursor-pointer hover:-translate-y-2"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-[#D96B33] to-[#B85A2B] rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 group-hover:rotate-3 transition-all duration-300">
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              
              <h3 className="text-2xl font-bold text-[#182114] mb-4" style={{ fontFamily: '"Distro Bold", sans-serif' }}>
                {service.title}
              </h3>
              
              <p className="text-[#2E3F25] mb-6 leading-relaxed" style={{ fontFamily: '"Century Gothic", sans-serif' }}>
                {service.description}
              </p>

              {service.subtitle && (
                <p className="text-[#182114] font-semibold mb-4" style={{ fontFamily: '"Century Gothic", sans-serif' }}>
                  {service.subtitle}
                </p>
              )}

              <ul className="space-y-2">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-start gap-3 text-[#2E3F25]" style={{ fontFamily: '"Century Gothic", sans-serif' }}>
                    <i className="ri-check-line text-[#D96B33] text-lg mt-0.5 flex-shrink-0"></i>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}